<template>
  <div>
    <v-row>
      <v-col class="mt-2 pt-2">
        <v-divider></v-divider>
        <label class="text-h6 text-weight-black mt-4">Ficha Técnica</label>
      </v-col>
    </v-row>
    <v-row v-if="productSelected.release">
      <v-col>
        <v-chip color="green" label text-color="white">
          <v-icon left> mdi-label </v-icon>
          Lançamento
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ul v-if="false">
          <li>Solado Exclusivo: Sim</li>
          <li>Solado: Couro</li>
          <li>Forro: Com Forro</li>
          <li>Material do Forro: Tecido</li>
          <li>Palmilha: Tecido</li>
        </ul>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    productSelected: {},
  },
};
</script>
